






























import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

@Component
export default class PaginationComponent extends Vue {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop() pagination!: any;

  @Prop() color?: string;

  @Prop({
    required: false,
    default: () => [5, 10, 15, 30, 45, 60],
  }) options!: string[];

  private get length(): number {
    const pageCount: number = Math.ceil(this.pagination.total / this.pagination.itemsPerPage);
    return pageCount === 0 ? 1 : pageCount;
  }

  private get index(): string {
    let end = Math.ceil(this.pagination.page * this.pagination.itemsPerPage);
    const start = end - this.pagination.itemsPerPage + 1;
    if (end > this.pagination.total) {
      end = this.pagination.total;
    }
    return `${start}-${end} de ${this.pagination.total}`;
  }

  private send() {
    this.$emit('input', this.pagination);
  }
}

export { PaginationComponent as VbPagination };
